import { render, staticRenderFns } from "./Organizacao.vue?vue&type=template&id=dd36091e"
import script from "./Organizacao.vue?vue&type=script&lang=js"
export * from "./Organizacao.vue?vue&type=script&lang=js"
import style0 from "./Organizacao.vue?vue&type=style&index=0&id=dd36091e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports